import { Icon, Flex } from '../component-library';
import styled from '@emotion/styled';

const StyledInput = styled.input`
  border: 0px;
  font-size: 16px;
  padding-left: 20px;
  width: 100%;
  background: transparent;
  &:focus {
    outline: none;
  }
`;

const IconInput = ({ icon, type, required, onChange }) => {
  return (
    <label style={{ width: '100%' }}>
      <Flex width='100%' alignItems='center' boxShadow='0px 2px 5px rgba(160, 160, 160, 0.5)' mb='30px' bg='#FFFFFF' p={10}>
        <Icon icon={icon} size={30} />
        <StyledInput type={type} onChange={onChange} required={required} />
      </Flex>
    </label>
  );
};

export default IconInput;
